export default "__VITE_PUBLIC_ASSET__043773e4__"